import { ImageRepository } from '../../domain/repositories/image.repository';
import { ImageEntity, ImageProps } from '../../domain/entities/image.entity';
import { IHttpClient } from '../../application/interfaces/http-client.interface';
import { resolveMediaUrl } from '../utils/media-url.helper';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  total?: number;
  message?: string;
}

export class HttpImageRepository implements ImageRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  public async getImages(search?: string): Promise<ImageEntity[]> {
    const query = search?.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
    const res = await this.httpClient.get<ApiResponse<ImageProps[]>>(`/images${query}`);

    if (!res.success || !res.data) {
      return [];
    }

    return res.data.map((item) => new ImageEntity({
      ...item,
      url: resolveMediaUrl(item.url),
    }));
  }

  public async deleteImage(id: string): Promise<void> {
    const res = await this.httpClient.delete<ApiResponse<void>>(`/images/${id}`);
    if (!res.success) {
      throw new Error(res.message || 'Error al eliminar la imagen del servidor.');
    }
  }
}
